import React from 'react';

const NoWishListItemFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/your-wishlist-is-empty.png"} width="300" />
    </div>;
}

export default NoWishListItemFound;